import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import '@/assets/scss/style.scss'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Intro } from '@/components/Intro'
import { ScanResults } from '@/components/ScanResults'
import { EmailForm } from '@/components/EmailForm'
import Layout from './components/Layout'
import TermsOfUse from './components/Terms/TermsOfUse'
import PrivacyPolicy from './components/Terms/PrivacyPolicy'
import ReactPixel from 'react-facebook-pixel'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'

const ThankYou = lazy(() => import('./components/ThankYou/ThankYou'))
const Paywall = lazy(() => import('./components/Paywall/Paywall'))
const Upsell = lazy(() => import('./components/Upsell'))

const mainPixelId = process.env.REACT_APP_FB_PIXEL_ID ?? ''
const secondPixelId = process.env.REACT_APP_FB_PIXEL_SECOND_ID ?? ''

const secondPixel = window.localStorage.getItem('pixelVersion')

if (window.location.pathname.startsWith('/intro1') || secondPixel === 'v2') {
  ReactPixel.init(secondPixelId)
  window.localStorage.setItem('pixelVersion', 'v2')
} else {
  ReactPixel.init(mainPixelId)
  window.localStorage.setItem('pixelVersion', 'v1')
}

amplitude.init('c8c7c772e17144633dd177d621ed0f0c', { defaultTracking: true })
const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 })
amplitude.add(sessionReplayTracking)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Router>
    <Suspense>
      <Layout>
        <Routes>
          <Route path="/" Component={(props) => <Intro isWhitePage={true} {...props} />} />
          <Route path="/intro" Component={(props) => <Intro {...props} />} />
          <Route path="/intro1" Component={(props) => <Intro {...props} />} />
          <Route path="/scan-results" Component={(props) => <ScanResults {...props} />} />
          <Route path="/email" Component={(props) => <EmailForm {...props} />} />

          <Route
            path="/paywall"
            Component={(props) => (
              <Paywall
                paywallFile={
                  process.env.REACT_APP_MODE !== 'dev' ? 'paywall-prod.json' : 'paywall-dev.json'
                }
                {...props}
              />
            )}
          />

          <Route
            path="/upsell"
            Component={(props) => (
              <Upsell
                upsellFile={
                  process.env.REACT_APP_MODE !== 'dev' ? 'upsell-prod.json' : 'upsell-dev.json'
                }
                {...props}
              />
            )}
          />

          <Route path="/terms-of-use" Component={(props) => <TermsOfUse {...props} />} />
          <Route path="/privacy-policy" Component={(props) => <PrivacyPolicy {...props} />} />
          <Route path="/thank-you" Component={(props) => <ThankYou {...props} />} />
        </Routes>
      </Layout>
    </Suspense>
  </Router>,
)
